var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileNameEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.1667V11.3463L10.9921 0.358958C11.1181 0.244513 11.2572 0.156111 11.4094 0.09375C11.5617 0.03125 11.7215 0 11.8885 0C12.0556 0 12.2174 0.0296532 12.374 0.0889587C12.5306 0.148264 12.6693 0.242569 12.79 0.371875L13.8077 1.40229C13.937 1.52299 14.0292 1.66188 14.0842 1.81896C14.1392 1.97604 14.1667 2.13312 14.1667 2.29021C14.1667 2.45785 14.1381 2.61778 14.0808 2.77C14.0236 2.92236 13.9326 3.06153 13.8077 3.1875L2.82042 14.1667H0ZM11.71 3.49521L12.9167 2.29646L11.8702 1.25L10.6715 2.45667L11.71 3.49521Z",
    fill: "#6E6E6E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileNameEdit);
export default __webpack_public_path__ + "static/media/file_name_edit.50e1fe11daeaf2364e281705ec54fde4.svg";
export { ForwardRef as ReactComponent };